var _circle, _path, _path2, _g, _rect, _path3, _path4, _g2, _circle2, _circle3, _path5, _ellipse, _ellipse2, _path6, _circle4, _path7, _path8, _path9, _path0, _rect2, _rect3, _path1, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path10, _g3, _rect12, _circle10, _circle11, _rect13, _rect14, _rect15, _rect16, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg503 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 288,
  height: 288,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 144,
  r: 144,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7FC",
  d: "M80.595 199C62.046 199 44 202.441 44 206.647c0 6.882 36.595 4.206 44.114 4.206 7.52 0 31.08-1.912 45.618-2.294 14.537-.383 21.555 3.441 43.612 3.441s21.556-3.441 29.577-5.353c8.02-1.912 27.571.382 27.07-3.441-.401-3.059-7.854-4.079-11.53-4.206z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M95.5 179.5s14 1.5 12 6-17.5 8-17.5 8M72 179.5s13.5 2.5 11.5 7S67 194 67 194"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#503_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 87,
  height: 43,
  x: 46.039,
  y: 135.015,
  fill: "#9298B9",
  rx: 21.5,
  transform: "rotate(2.646 46.039 135.015)"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 4,
  x: 72,
  y: 138,
  fill: "#223",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M89 139.5c4.5-4 8-9.5 8-12.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#9298B9",
  d: "M60 197.2a7.2 7.2 0 0 1 7.2-7.2h8.6a7.2 7.2 0 0 1 7.2 7.2 1.8 1.8 0 0 1-1.8 1.8H61.8a1.8 1.8 0 0 1-1.8-1.8M86 197.2a7.2 7.2 0 0 1 7.2-7.2h8.6a7.2 7.2 0 0 1 7.2 7.2 1.8 1.8 0 0 1-1.8 1.8H87.8a1.8 1.8 0 0 1-1.8-1.8"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#503_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 31,
  x: 75,
  y: 103,
  fill: "#9298B9",
  rx: 15.5
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 91.464,
  cy: 103.464,
  r: 4,
  fill: "#9298B9",
  transform: "rotate(-30 91.464 103.464)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 110.392,
  cy: 103.464,
  r: 4,
  fill: "#9298B9",
  transform: "rotate(-30 110.392 103.464)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#223",
  d: "M94 121.5a7.5 7.5 0 0 1 7.5-7.5h15a7.5 7.5 0 0 1 0 15h-15a7.5 7.5 0 0 1-7.5-7.5"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 101.143,
  cy: 121.5,
  fill: "#D9DBE9",
  rx: 3.571,
  ry: 3.75
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 116.857,
  cy: 121.5,
  fill: "#D9DBE9",
  rx: 3.571,
  ry: 3.75
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M127 149c14 4.523 19 23.523 28.5 23.523"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 172,
  r: 8,
  fill: "#9298B9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6F6F7E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M74.679 140.018c5.333-3.166 11.4-9.4-7-9-23 .5-28.358 22.482-30.679 35-2.48 13.374-18.82 35 14.68 34s8.5-36 30-36c21.499 0 38.611 24.615 55.32 21.482 16-3 16.5-21.482 28.679-19.482"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9DBE9",
  d: "M188 101a5 5 0 0 1 5-5h32a5 5 0 0 1 5 5v98h-42z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6F6F7E",
  d: "M190 103.5c-.5-4.667-.7-14 2.5-14s5 9.333 5.5 14h1.5c-.833-4.667-1.2-14 4-14s5.167 9.333 4.5 14l3 4c1-.833 3.5-2 5.5 0 2.5 2.5-2 15 0 17 1.6 1.6 3.667 1.333 4.5 1"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#6F6F7E",
  d: "m177.505 158.477-.514 13.99-5.996-.22a7 7 0 0 1-6.738-7.252 7 7 0 0 1 7.252-6.738z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  x: 182.391,
  y: 161.658,
  fill: "#6F6F7E",
  rx: 1,
  transform: "rotate(92.101 182.391 161.658)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  x: 182.171,
  y: 167.654,
  fill: "#6F6F7E",
  rx: 1,
  transform: "rotate(92.101 182.171 167.654)"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6F6F7E",
  d: "M229 144.5c4.5.5 13.1 2.5 11.5 6.5s-7.667 3.667-10.5 3c4.833 2.833 13.7 9.1 10.5 11.5s-9 1-11.5 0c5.667 3.333 15.9 10.6 11.5 13s-8.833.333-10.5-1h-3.5c.667 2.833 1.6 8.8 0 10s-3.667 1.833-4.5 2"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 190.5,
  cy: 108.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 227.5,
  cy: 155.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 227.5,
  cy: 165.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 227.5,
  cy: 175.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 198.5,
  cy: 108.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 227.5,
  cy: 145.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 207.5,
  cy: 108.5,
  r: 5.5,
  fill: "#ADB0C8"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 7,
  x: 189,
  y: 115,
  fill: "#878EB0",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 7,
  x: 195,
  y: 115,
  fill: "#878EB0",
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 7,
  x: 189,
  y: 123,
  fill: "#878EB0",
  rx: 2
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 7,
  x: 195,
  y: 123,
  fill: "#878EB0",
  rx: 2
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 201,
  y: 123,
  fill: "#878EB0",
  rx: 1.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 201,
  y: 127,
  fill: "#878EB0",
  rx: 1.5
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 201,
  y: 119,
  fill: "#878EB0",
  rx: 1.5
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 210,
  y: 115,
  fill: "#878EB0",
  rx: 1.5
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 215,
  y: 124,
  fill: "#878EB0",
  rx: 1.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 3,
  x: 189,
  y: 131,
  fill: "#878EB0",
  rx: 1.5
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9DBE9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M80 162c-21 6-38-17-24-18.5"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#503_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 163,
  r: 8,
  fill: "#9298B9"
}))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 18,
  x: 191,
  y: 157,
  fill: "#6F6F7E",
  rx: 3
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 193.5,
  cy: 162.5,
  r: 1.5,
  fill: "#223"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 193.5,
  cy: 168.5,
  r: 1.5,
  fill: "#223"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 16,
  x: 217,
  y: 181,
  fill: "#878EB0",
  rx: 1
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 16,
  x: 213,
  y: 181,
  fill: "#878EB0",
  rx: 1
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 16,
  x: 209,
  y: 181,
  fill: "#878EB0",
  rx: 1
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 16,
  x: 221,
  y: 181,
  fill: "#878EB0",
  rx: 1
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6F6F7E",
  d: "M222 145.5c-3.667.667-6.541.8-2.941 2 4.5 1.5 9.5 6.5 12 4.5s-14-3-13 0 9.5 7 13 5.5-13-4.5-12 0 12.06 9.5 12 7.5c-.059-2-12.759-4.2-11.559-1s3.167 3.333 3.5 3"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "503_svg__a",
  width: 86.954,
  height: 45.032,
  x: 45.023,
  y: 135.984,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 14,
  result: "effect1_innerShadow_1_844"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 30,
  dy: -5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_1_844"
})), /*#__PURE__*/React.createElement("filter", {
  id: "503_svg__b",
  width: 54,
  height: 31,
  x: 75,
  y: 103,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 23,
  result: "effect1_innerShadow_1_844"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 30,
  dy: -10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_1_844"
})), /*#__PURE__*/React.createElement("filter", {
  id: "503_svg__c",
  width: 16,
  height: 16,
  x: 77,
  y: 155,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 24,
  result: "effect1_innerShadow_1_844"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 30,
  dy: -39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_1_844"
})))));
export default Svg503;